(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('pocf', {
        templateUrl: 'views/components/views/pocf/pocf.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'pocfService', 'typeaheadService', function ($stateParams, stateService, utilityService, modalService, translateService, pocfService, typeaheadService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;
            
            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                labourNameButtons: [
                    { id: 'goto', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => stateService.go('selectlabourpu', { webpagename: stateService.getCurrentName() }) }
                ],
                barcodeButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.barcode = '' },
                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator() },
                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => vm.searchBarcode() }
                ],
                productIdButtons: [
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_keyno }) }
                ],
                stockValueBeforeButtons: [
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockget', { stock_keyno: vm.model.edit.stock_keyno }) }
                ],
                edit: {},
                itemsListComponents: [],
                lockedCreate: false,
                lockedSave: false,
                lockedAbort: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS
            
            async function loadEdit() {
                vm.model.edit = (await pocfService.getEdit({
                    argtype: argType,
                    argvalue: argValue
                }))[0];
            }
            
            async function loadComponents() {
                if (vm.model.edit.po_keyno > 0) {
                    return vm.model.itemsListComponents = await pocfService.listComponents(vm.model.edit);
                }
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

            function openCalculator() {
                modalService.showCalculator(vm.model.edit.barcode).then(function (value) {
                    vm.model.edit.barcode = value;
                    vm.searchBarcode();
                });
            }

            // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

            // #region SEARCH BUTTON FUNCTION
            
            vm.searchBarcode = function () {
                if (utilityService.validateParmsValue(vm.model.edit.labour_name) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.barcode) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.quantity) !== true) return;
                
                pocfService.scanBarcode(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.edit.barcode = '';
                                }
                            }]
                        });
                    } else {
                        vm.model.edit.barcode = '';
                        vm.model.edit.searchtext = response[0].searchtext;
                        vm.model.edit.stock_keyno = response[0].stock_keyno;
                    }
                });
            }

            // #endregion SEARCH BUTTON FUNCTION

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'searchtext':
                        vm.model.edit[id] = value;

                        return typeaheadService.lookUpSuggestions(vm.model.edit);
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'searchtext':
                        if (item) {
                            vm.model.edit.stock_keyno = item?.item_id ?? '0';
                            vm.model.edit.searchtext = item?.item_name ?? '';
                        } else {
                            vm.onTypeaheadClear('searchtext');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'searchtext':
                        vm.model.edit.searchtext = value;

                        if (value) {
                            if (item?.item_id) {
                                vm.model.edit.stock_keyno = item.item_id;
                            }
                        } else {
                            vm.onTypeaheadClear('searchtext');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'searchtext':
                        vm.model.edit.stock_keyno = '0';
                        vm.model.edit.searchtext = '';
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region CREATE BUTTON FUNCTION
            
            vm.createChanges = function () {
                vm.model.lockedCreate = true;
                
                pocfService.createObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedCreate = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedCreate = false;
                        vm.model.edit.po_keyno = response[0].po_keyno;

                        loadEdit();
                    }
                });
            }

            // #endregion CREATE BUTTON FUNCTION

            // #region SAVE BUTTON FUNCTIONS
            
            function loadSave() {
                pocfService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        vm.model.itemsListComponents = [];

                        loadEdit();
                    }
                });
            }
            
            vm.saveChanges = function () {
                vm.model.lockedSave = true;
                
                pocfService.createPoFinish(vm.model.edit).then(function (response) {
                    vm.model.edit.p2_pofinish_keyno = response[0].p2_pofinish_keyno;
                    vm.model.edit.p2_pofinishprod_keyno = response[0].p2_pofinishprod_keyno;
                    
                    loadSave();
                });
            }

            // #endregion SAVE BUTTON FUNCTIONS

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.abortValues = function () {
                vm.model.lockedAbort = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    pocfService.abortObj(vm.model.edit).then(function (response) {
                        if (response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                                        vm.model.lockedAbort = false;
                        			}
                        		}]
                        	});
                        } else {
                            vm.model.lockedAbort = false;
                            vm.model.itemsListComponents = [];

                            loadEdit();
                        }
                    }, function () {
                        vm.model.lockedAbort = false;
                    });
                }, function () {
                    vm.model.lockedAbort = false;
                });
            }

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();
                loadComponents();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
